import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import VehicleList from "../components/VehicleList";
import SparePartsList from "../components/SparePartsList";
import { sanityClient } from "../lib/sanityClient";

function Shop() {
  const [spareParts, setSpareParts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpareParts = async () => {
      try {
        const query = `*[_type == "sparePart"]{
          _id, name, price, description, compatibility, primaryImage
        }`;
        const fetchedParts = await sanityClient.fetch(query);
        setSpareParts(fetchedParts);
      } catch (error) {
        console.error("Error fetching spare parts:", error);
      }
      setLoading(false);
    };

    fetchSpareParts();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Shop used and brand new cars in Cameroon| spare parts|237Mechanic</title>
        <meta
          name="description"
          content="Explore our shop for high-quality vehicles and spare parts. We offer brand-new cars, used cars, and genuine spare parts for your automotive needs."
        />
        <link rel="canonical" href="https://237mechanic.com/cm/en/shop"/>
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">Welcome to Our Shop</h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        Browse through our collection of brand-new cars, used cars, and high-quality spare parts for sale in Cameroon.
        We ensure top-tier quality and reliability in all our products.
      </p>

      <div className="space-y-12">
        <section>
          <h2 className="text-2xl font-semibold mb-4">Brand New Cars</h2>
          <VehicleList categorySlug="brand-new-cars" />
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Used Cars</h2>
          <VehicleList categorySlug="used-cars" />
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Spare Parts</h2>
          {loading ? (
            <p className="text-center text-gray-500">Loading spare parts...</p>
          ) : spareParts.length > 0 ? (
            <SparePartsList spareParts={spareParts} />
          ) : (
            <p className="text-center text-gray-500">No spare parts available at the moment.</p>
          )}
        </section>
      </div>
    </div>
  );
}

export default Shop;
